import {useQuery} from '@apollo/react-hooks';
import {DataProxy} from 'apollo-cache';
import gql from 'graphql-tag';
import {User} from './auth.datatypes';
import {gqlBillingPartyMember} from '../../views/BillingParty/getBillingParty.api';
import {gqlGroupMember} from '../../views/Groups/getGroupMember.api';

interface MeData {
  me: User
}

export const gqlLoggedInUser = `
  id
  email
  first_name
  last_name
  email_opt_out
  sms_opt_out
  cellphone
  cellphone_code
  locale
  onetime_password
  email_verified

  roles {
    id
    ident
    name
    level
  }

  permissions {
    id
    ident
  }

  permissionIdents

  groupMembers {
    id
    group_role
    group_id
  }

  associatedGroups {
    id
  }

  myGroups {
    id
  }

  myBillingParties {
    id
  }

  leaderInGroups {
    id
  }

  billingPartyMembers {
    id
    primary_paying_member

    billingParty {
        id
        soft_cancelled
        code
        overduePayments
        members {
            id
        }
        cancelled_members {
            id
        }

        booking {
            id
            group_id
            group {
                id
                editing_level
            }
        }
    }
  }

  myBillingParties{
    id
    group_booking_id
    credit_card_fee
    soft_cancelled
    disabled
    cost
    outstandingBalance
    overduePayments
    totalCreditCardFees

    booking {
        id
        group_id
        cost
        outstandingBalance
        overduePayments

        group {
            id
            editing_level
            cost
            outstandingBalance
            overduePayments
        }
    }

    payingMembers {
        ${gqlBillingPartyMember}
    }

    members {
        id
        room_party_id
        group_member_id
        billing_party_id
        primary_occupant
        guest_number

        groupMember {
            ${gqlGroupMember}
        }

        billingParty {
            id

            payingMembers {
                id
            }
        }

        options {
            id
            group_resource_option_id
            unit_count
            unit_cost

            groupResourceOption {
                id

                option {
                    id
                    internal_name
                }
            }
        }
    }
  }
`;

export const GET_ME_QUERY = gql`
    query getMe{
        me{
          ${gqlLoggedInUser}
        }
    }
`;

export const getMe = () => useQuery<MeData>(
  GET_ME_QUERY,
  {}
);

export const setMe = (proxy: DataProxy, me: User) => {
  proxy.writeQuery({
    query: GET_ME_QUERY,
    data: { me },
  })
};

export default getMe;

